<div class="artist-catalog" [class.image-mode]="displayMode === 'image'">
  @if (displayMode === 'catalog') {
    <!-- Catalog mode with items list -->
    <div class="catalog-header">
      <a [href]="artistImageLink" class="artist-image-link">
        <img [src]="artistImage" [alt]="artistName" class="artist-image" />
      </a>
      <div class="artist-info">
        <div class="category-wrapper">
          <img
            src="assets/icons/music-cd.svg"
            alt="catalog icon"
            class="catalog-icon" />
          <span class="category">
            {{ 'lang.portfolio.catalog.category' | transloco }}
          </span>
        </div>
        <h3 class="title">{{ 'lang.portfolio.catalog.mySongs' | transloco }}</h3>
        <p class="artist-name">{{ artistName }}</p>
      </div>
    </div>

    <div class="items-counter">
      <span class="counter-text">
        <strong>{{ items.length }}</strong>
        itens
      </span>
    </div>

    <div class="catalog-list">
      <div *ngFor="let item of items" class="catalog-item-wrapper">
        <div class="catalog-item">
          <img [src]="item.image" [alt]="item.title" class="item-image" />
        </div>
      </div>
    </div>
  } @else {
    <!-- Image mode with large background image -->
    <div class="image-background">
      <img [src]="artistImage" [alt]="title" class="background-image" />
    </div>
  }

  <div class="info-block">
    <h3 class="info-title">{{ title }}</h3>
    <p class="info-description">{{ description }}</p>
  </div>
</div>
